module.exports = "/365FarmNet/dist/seedCoreCustomHeader.b12ddd3b0814e96a6988b38d73a143e5.html";